import Link from 'next/link';

const Banner = () => (
  <div className="banner">
    <img src={require('./banner.jpg')} alt="presentation" className="banner__img"/>
    <div className="container">
      <div className="banner__content">
        <h2 className="banner__title">
          Intelligent
          <br/>
          AAD solutions
        </h2>
        <Link href="/products">
          <a className="header-btn primary-btn">Explore our products</a>
        </Link>
      </div>
    </div>
  </div>
);

export default Banner;